import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PaperclipOutlinedIcon } from '@getgo/chameleon-icons/react';
import { IconButton } from '@getgo/chameleon-web/react';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { v1 as uuidv1 } from 'uuid';
import classes from './FilePicker.module.scss';
export const acceptedMimeTypes = [
    'application/json',
    'application/ogg',
    'application/pdf',
    'application/rtf',
    'application/zip',
    'application/x-tar',
    'application/xml',
    'application/gzip',
    'application/x-bzip2',
    'application/x-gzip',
    'application/smil',
    'application/javascript',
    'audio/mp4',
    'audio/mpeg',
    'audio/ogg',
    'audio/flac',
    'audio/webm',
    'audio/wav',
    'audio/amr',
    'audio/3gpp',
    'image/bmp',
    'image/gif',
    'image/jpg',
    'image/jpeg',
    'image/pjpeg',
    'image/png',
    'image/svg+xml',
    'image/tiff',
    'image/webp',
    'image/x-icon',
    'text/css',
    'text/csv',
    'text/html',
    'text/calendar',
    'text/plain',
    'text/javascript',
    'text/vcard',
    'text/vnd.wap.wml',
    'text/xml',
    'video/avi',
    'video/mp4',
    'video/mpeg',
    'video/ogg',
    'video/quicktime',
    'video/webm',
    'video/x-ms-wmv',
    'video/x-flv',
];
const BASE64_PREFIX = 'base64,';
const convertToBase64 = async (file) => {
    const fileReader = new FileReader();
    return new Promise((resolve, reject) => {
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
            const base64Encoded = fileReader.result;
            const content = base64Encoded.slice(base64Encoded.indexOf(BASE64_PREFIX) + BASE64_PREFIX.length);
            resolve({
                file,
                filename: file.name,
                contentType: file.type,
                content,
                size: file.size,
                id: uuidv1(),
            });
        };
        fileReader.onerror = () => {
            reject();
        };
    });
};
export const onChange = async (event, callback) => {
    const currentTarget = event.currentTarget;
    const files = currentTarget.files;
    if ((files === null || files === void 0 ? void 0 : files.length) && callback) {
        const newFiles = await Promise.all([...files].map(convertToBase64));
        callback(newFiles);
    }
    currentTarget.value = '';
};
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const FilePicker = ({ color, onAddFiles, disabled, }) => {
    console.warn('FilePicker is deprecated, use @ucc-messaging/inbox-common-ui instead');
    const acceptedMimeTypesJoined = useMemo(() => acceptedMimeTypes.join(', '), [acceptedMimeTypes]);
    const { t } = useTranslation();
    const hiddenFileInput = React.useRef(null);
    return (_jsxs("label", Object.assign({ className: classNames(classes.label), "aria-label": t('File picker'), "data-testid": "file-picker-label" }, { children: [_jsx(IconButton, Object.assign({ disabled: disabled, onClick: () => {
                    if (hiddenFileInput.current) {
                        hiddenFileInput.current.click();
                    }
                } }, { children: _jsx(PaperclipOutlinedIcon, { style: !disabled && color && { color } }, void 0) }), void 0), _jsx("input", { ref: hiddenFileInput, tabIndex: -1, type: "file", disabled: disabled, accept: acceptedMimeTypesJoined, onChange: (event) => onChange(event, onAddFiles), className: classNames(classes.input), "data-testid": "file-picker-input", multiple: true }, void 0)] }), void 0));
};
export default FilePicker;
//# sourceMappingURL=FilePicker.js.map